// extracted by mini-css-extract-plugin
export default {"hosted":"style_hosted__CmxQ0","content":"style_content__kcpK8"};